export const wordBreak = {
  normal: "break-normal",
  words: "break-words",
  all: "break-all",
  keep: "keep-all",
}

export type WordBreak = keyof typeof wordBreak
